[
  {
    "streamKey": "N71102",
    "studioCode": "MRH",
    "gameCode": "SIC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "deviceQuality": "MB",
    "url": "https://live.youxiuzaoxing.xyz/nlive/N71102.flv"
  },
  {
    "streamKey": "8-111",
    "studioCode": "PTM5",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "deviceQuality": "MB",
    "url": "https://live.wxadg.top/nw01/8-111.flv"
  },
  {
    "streamKey": "8-112",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "deviceQuality": "MB",
    "url": "https://live.wxadg.top/nw01/8-112.flv"
  },
  {
    "streamKey": "8-51",
    "studioCode": "MRH-L1",
    "gameCode": "BJ",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "deviceQuality": "MB",
    "url": "https://live.wxadg.top/nw05/8-51.flv"
  },
  {
    "streamKey": "L044-00-1-1",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "deviceQuality": "MB",
    "url": "https://millicast.com/L044-00-1-1"
  },
  {
    "streamKey": "N020-00-1-2",
    "studioCode": "MRH",
    "gameCode": "DT",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "deviceQuality": "MB",
    "url": "https://millicast.com/N020-00-1-2"
  },
  {
    "streamKey": "M001",
    "studioCode": "MRH",
    "gameCode": "ROU",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "M004",
    "studioCode": "MRH",
    "gameCode": "ROU",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "M002",
    "studioCode": "MRH",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L001",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L002",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L003",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L004",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L005",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L006",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L007",
    "studioCode": "PTM5",
    "gameCode": "3F",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L008",
    "studioCode": "PTM5",
    "gameCode": "NIU",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L009",
    "studioCode": "PTM5",
    "gameCode": "W3C",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L010",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L011",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L012",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L013",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L014",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L015",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L016",
    "studioCode": "PTM5",
    "gameCode": "NIU",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L017",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L018",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L019",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L020",
    "studioCode": "PTM5",
    "gameCode": "DT",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L021",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L022",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L023",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L024",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L025",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L026",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L027",
    "studioCode": "PTM5",
    "gameCode": "DTW",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L028",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L029",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L030",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L031",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L032",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L033",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L034",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L035",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L036",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L037",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L038",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L039",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L040",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L041",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L042",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L043",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L044",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L045",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L046",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L047",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L048",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L049",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L050",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L051",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L052",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L053",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "L054",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L055",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L056",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L057",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "L058",
    "studioCode": "PTM5",
    "gameCode": "BAC",
    "brand": [
      "eeze"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D010",
    "studioCode": "PTM-RLG",
    "gameCode": "SIC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D001",
    "studioCode": "PTM-RLG",
    "gameCode": "ROU",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D051",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D052",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D053",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D011",
    "studioCode": "PTM-RLG",
    "gameCode": "SIC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D054",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D058",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D059",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Normal",
    "url": null
  },
  {
    "streamKey": "D021",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D022",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D023",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D024",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D025",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D026",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D027",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D028",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D029",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D030",
    "studioCode": "PTM-RLG",
    "gameCode": "BJ",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D055",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D056",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D057",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D065",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D066",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D067",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D068",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D069",
    "studioCode": "PTM-RLG",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "D060",
    "studioCode": "PTM-RLG",
    "gameCode": "DT",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P015",
    "studioCode": "PT",
    "gameCode": "SIC",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P003",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P007",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P018",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P016",
    "studioCode": "PT",
    "gameCode": "MWSIC",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P020",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P060",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P061",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Choice"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P070",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P063",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P064",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P072",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "eeze"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P001",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P002",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P004",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P005",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P006",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P017",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P019",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P021",
    "studioCode": "PT",
    "gameCode": "BAC",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P008",
    "studioCode": "PT",
    "gameCode": "DT",
    "brand": [
      "Choice"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P067",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "eeze"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "P062",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P065",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P066",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P071",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Speed",
    "url": null
  },
  {
    "streamKey": "P069",
    "studioCode": "PT",
    "gameCode": "ROU",
    "brand": [
      "Lucky"
    ],
    "tableType": "Super Speed",
    "url": null
  },
  {
    "streamKey": "R002",
    "studioCode": "RLG",
    "gameCode": "MWMJ",
    "brand": [
      "Lucky"
    ],
    "tableType": "TBC",
    "url": null
  },
  {
    "streamKey": "R004",
    "studioCode": "RLG",
    "gameCode": "12D",
    "brand": [
      "Lucky"
    ],
    "tableType": "TBC",
    "url": null
  },
  {
    "streamKey": "R003",
    "studioCode": "RLG",
    "gameCode": "RW",
    "brand": [
      "Lucky"
    ],
    "tableType": "TBC",
    "url": null
  }
]
